const INVITATION_MAP_KEY = "hub-invitation-map"

type InvitationMap = Record<string, number>

const safeReadMap = (): InvitationMap => {
  try {
    const raw = localStorage.getItem(INVITATION_MAP_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return typeof parsed === "object" && parsed !== null
      ? (parsed as InvitationMap)
      : {}
  } catch {
    return {}
  }
}

const safeWriteMap = (map: InvitationMap) => {
  try {
    localStorage.setItem(INVITATION_MAP_KEY, JSON.stringify(map))
  } catch {
    // privacy mode / storage unavailable — best effort, mismatch detection
    // simply degrades to "always trust cookie" for users with no storage.
  }
}

export const cacheInvitationMapping = (
  token_id: string,
  invitation_id: number,
) => {
  const map = safeReadMap()
  map[token_id] = invitation_id
  safeWriteMap(map)
}

export const getCachedInvitationId = (token_id: string): number | undefined => {
  return safeReadMap()[token_id]
}
